export default () => {
  return {
    fetch: useRpcCall('searchProductsByOrderNumber'),
  }
}
